<script setup lang="ts">
const props = defineProps<{
  current: number;
  max: number;
  appendQueryKey?: string[];
}>();

defineEmits({
  "update:current": (value: number) => true,
});

const pagination = computed(() => {
  // 現在のページ
  const c = props.current;
  // 最大ページ数
  const m = props.max;
  // 表示件数
  const count = 5;

  const _data: {
    start: number;
    end: number;
    next: number;
    prev: number;
    list: number[];
  } = {
    start: 0,
    end: 0,
    next: 0,
    prev: 0,
    list: [],
  };

  // 最大件数が表示兼素に満たない場合
  if (m && m < count) {
    for (let i = 1; i < m + 1; i++) {
      _data.list.push(i);
    }
  } else {
    // TODO: ここはもう少し綺麗に書ける
    for (let i = 1 < c - 1 ? c - 1 : 1; i <= c + 3; i++) {
      if (i < 0) continue;
      if (m && m + 1 <= i) break;
      _data.list.push(i);
    }
  }

  return _data;
});

const currentQuery = computed(() => useRoute().query);
function navigate(off: number) {
  return {
    query: {
      ...currentQuery.value,
      off,
    },
  };
}
</script>

<template>
  <ul class="pagination">
    <li class="pagination__item" v-if="0 < current">
      <NuxtLink
        :to="navigate(0)"
        class="pagination__link first"
        aria-label="first"
      >
        <Icon size="18" name="mdi:chevron-double-left" />
      </NuxtLink>
    </li>
    <li class="pagination__item" v-if="0 < current">
      <NuxtLink
        :to="navigate(current - 1)"
        class="pagination__link prev"
        aria-label="prev"
      >
        <Icon size="18" name="mdi:chevron-left" />
      </NuxtLink>
    </li>

    <li
      class="pagination__item"
      v-for="i in pagination.list"
      :class="{ current: i - 1 == current }"
      :key="i"
    >
      <NuxtLink :to="navigate(i - 1)" class="pagination__link">
        {{ i }}</NuxtLink
      >
    </li>

    <li class="pagination__item" v-if="current < props.max - 1">
      <NuxtLink
        :to="navigate(current + 1)"
        class="pagination__link next"
        aria-label="next"
      >
        <Icon size="18" name="mdi:chevron-right" />
      </NuxtLink>
    </li>
    <li class="pagination__item" v-if="current < props.max - 1">
      <NuxtLink
        :to="navigate(props.max - 1)"
        class="pagination__link last"
        aria-label="last"
      >
        <Icon size="18" name="mdi:chevron-double-right" />
      </NuxtLink>
    </li>
  </ul>
</template>
<style scoped lang="scss">
.pagination {
  @apply flex justify-center gap-1;
  &__item {
    @apply w-[40px] bg-gray-200 aspect-square text-sm text-center rounded-full cursor-pointer hover:bg-opacity-50 whitespace-nowrap overflow-hidden;
    &.current {
      @apply bg-green-800 text-white;
    }
  }
  &__link {
    @apply w-full h-full  flex items-center justify-center;
  }
}
</style>
